<h2>Broadcasts</h2>

<div class="owner-switcher" *ngIf="isAdmin">
  <app-user-picker label="View broadcasts of user" (userSelected)="onOwnerSelected($event)"></app-user-picker>
  <div class="owner-switcher__status" *ngIf="!viewingSelf">
    <span>Viewing: <strong>{{ selectedOwnerLabel }}</strong> (read-only)</span>
    <button mat-stroked-button type="button" (click)="backToMyBroadcasts()">Back to my broadcasts</button>
  </div>
</div>

<mat-table [dataSource]="broadcasts$ | async">
  <ng-container matColumnDef="scheduled">
    <mat-header-cell *matHeaderCellDef> Scheduled </mat-header-cell>
    <mat-cell *matCellDef="let row"> {{ (row.scheduled || games[row.gameId]?.scheduled)?.toDate() | date: 'short' }} </mat-cell>
  </ng-container>
  <ng-container matColumnDef="lastUpdate">
    <mat-header-cell *matHeaderCellDef> Last update </mat-header-cell>
    <mat-cell *matCellDef="let row"> {{ games[row.gameId]?.lastUpdate?.toDate() | date: 'short' }} </mat-cell>
  </ng-container>
  <ng-container matColumnDef="title">
    <mat-header-cell *matHeaderCellDef> Title </mat-header-cell>
    <mat-cell *matCellDef="let row">
      <span *ngIf="row.uid === linkedBroadcastUid" class="linked-badge" aria-label="Linked to output">
        <span class="linked-badge__dot"></span>LINKED
      </span>
      {{row.config?.homeConfig?.fullName}} vs. {{row.config?.awayConfig?.fullName}}
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="gameId">
    <mat-header-cell *matHeaderCellDef> Game ID </mat-header-cell>
    <mat-cell *matCellDef="let row"> {{row.gameId}} </mat-cell>
  </ng-container>
  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
    <mat-cell *matCellDef="let row">
      <button *ngIf="viewingSelf" mat-stroked-button type="button"
              (click)="broadcastService.linkBroadcastToUserOutput(row.uid)"
              [disabled]="row.uid == authService.user.linkedBroadcastUid"
      >Link</button>
      <button mat-stroked-button type="button" routerLink="/broadcast/{{row.uid}}">Open</button>
      <a mat-stroked-button [routerLink]="['/score-sheet', row.uid]">Score sheet</a>
      <button *ngIf="isAdmin" mat-stroked-button type="button" (click)="openChangeOwner(row)">Change owner</button>
      <button *ngIf="viewingSelf && (authService.user.role === 'owner' || authService.user.role === 'admin')" mat-stroked-button type="button" (click)="deleteBroadcast(row)" [disabled]="row.uid === linkedBroadcastUid">Delete</button>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="inning">
    <mat-header-cell *matHeaderCellDef> Inning </mat-header-cell>
    <mat-cell *matCellDef="let row">
      {{games[row.gameId]?.inningPart}}{{games[row.gameId]?.inning}}
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="['scheduled', 'lastUpdate', 'gameId', 'title', 'inning', 'actions']"></mat-header-row>
  <mat-row *matRowDef="let row; columns: ['scheduled', 'lastUpdate', 'gameId', 'title', 'inning', 'actions']"
           [class.broadcast-row--linked]="row.uid === linkedBroadcastUid"></mat-row>
</mat-table>
<button *ngIf="viewingSelf" mat-flat-button color="primary" (click)="createBroadcast()">
  <mat-icon>add</mat-icon>
  Create broadcast
</button>
